const data = [
  { id: 0, name: 'Pendente' },
  { id: 1, name: 'Aprovada' },
  { id: 2, name: 'Rejeitada' },
  { id: 3, name: 'Em análise' },
  { id: 4, name: 'Documentos solicitados' },
  { id: 5, name: 'Documentos atualizados' },
  { id: 6, name: 'Certidão desatualizada' },
]

export default [...data]
